import React from "react"
import * as queryString from "query-string"
import ConfettiAnimation from "../../components/animations/ConfettiAnimation"

const ConfettiTime = ({location}) => {
    const { confetti} = queryString.parse(location.search);
    return (
        
        <div className="fixed right-0 top-0 w-screen h-screen pointer-events-none">
            {confetti &&  <ConfettiAnimation />}
      </div>
    )
}

export default ConfettiTime